import { useMutation } from '@apollo/client';
import {
    ConfirmEmail,
    ConfirmEmailVariables
} from 'libs/graphql/mutation/access/__generated__/ConfirmEmail';
import { CONFIRM_USER_EMAIL_MUTATION } from 'libs/graphql/mutation/access/accessMutation';
import { EToastType } from 'libs/types/site/IClient';
import { userMessage } from 'libs/utils/logic/ui/uiLogic';
import qs from 'query-string';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { GlobalContext } from 'session/state/context';
import { setLoggedUser } from 'session/state/user/userActions';
import { Localization } from 'static/localization/localization';

export const VerifyEmailPageContent = () => {
    const { dispatch } = useContext(GlobalContext);
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [hash, setHash] = useState('');

    const [submit] = useMutation<ConfirmEmail, ConfirmEmailVariables>(CONFIRM_USER_EMAIL_MUTATION);
    useEffect(() => {
        const params = qs.parse(location.search);
        setEmail(decodeURIComponent(params['email'] as string));
        setHash(params['hash'] as string);
    }, []);

    useEffect(() => {
        if (email && hash) {
            submit({
                variables: {
                    email,
                    hash
                },
                onCompleted: (result) => {
                    dispatch(
                        setLoggedUser(
                            result.confirmEmail?.user,
                            result.confirmEmail?.tokenType,
                            result.confirmEmail?.accessToken
                        )
                    );
                    userMessage(EToastType.SUCCESS, Localization.WELCOME);
                    navigate('/admin');
                },
                onError: (err) => {
                    const r = err.message;
                    if (r === 'USER_NOT_FOUND') {
                        userMessage(EToastType.ERROR, 'User not found');
                    } else if (
                        r === 'VERIFICATION_CODE_NOT_FOUND' ||
                        r === 'VERIFICATION_CODE_INVALID' ||
                        r === 'VERIFICATION_CODE_EXPIRED' ||
                        r === 'VERIFICATION_CODE_USED'
                    ) {
                        userMessage(
                            EToastType.ERROR,
                            'The verification code is invalid, please contact our support.'
                        );
                    } else {
                        userMessage(
                            EToastType.ERROR,
                            'Error while confirming email address. Please contact our support.'
                        );
                    }
                }
            });
        }
    }, [email, hash]);

    return <></>;
};
